import { render, staticRenderFns } from "./DaumPostCode.vue?vue&type=template&id=be662f60&"
import script from "./DaumPostCode.vue?vue&type=script&lang=js&"
export * from "./DaumPostCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports